import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleComponent } from '@keen.io/ui-core';
import { Container, MessageContainer, FullExtraction, FilteredExtraction, ClearProperties } from './ExtractionTitle.styles';

var ExtractionTitle = function ExtractionTitle(_ref) {
  var isFullExtraction = _ref.isFullExtraction,
      isDisabled = _ref.isDisabled,
      onClearProperties = _ref.onClearProperties;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(Container, null, React.createElement(TitleComponent, {
    isDisabled: isDisabled
  }, t('extraction.title')), !isDisabled && React.createElement(MessageContainer, null, isFullExtraction ? React.createElement(FullExtraction, null, t('extraction.full_extraction')) : React.createElement(FilteredExtraction, null, t('extraction.filtered_extraction'), ' ', React.createElement(ClearProperties, {
    role: "button",
    onClick: onClearProperties
  }, t('extraction.clear_properties')))));
};

export default ExtractionTitle;